import { INSPIRATION_FILTERS, productType } from "../../data/portfolio";

const pill = (on) => `rounded-full px-4 py-2 text-[14px] font-semibold transition-colors ${on ? "bg-ink text-white" : "bg-white text-slate-600 ring-1 ring-slate-200 hover:text-ink hover:ring-slate-300"}`;
const valueOf = (it, key) => (key === "type" ? productType(it.onderwerp) : it[key]);

export const matchInspiration = (it, filters) => Object.entries(filters).every(([k, v]) => !v || valueOf(it, k) === v);

// Producttype als tabs; materiaal, kleur, stijl en uitvoering als keuzelijsten. Alleen opties met beelden worden getoond.
export const InspirationFilters = ({ items, filters, setFilters, count }) => {
  const [typeF, ...rest] = INSPIRATION_FILTERS;
  const present = (key) => new Set(items.map((it) => valueOf(it, key)));
  const set = (k, v) => setFilters((f) => ({ ...f, [k]: v }));
  const active = Object.values(filters).some(Boolean);
  return (
    <div className="card p-4 sm:p-5" data-testid="inspiration-filter-bar">
      <div className="flex flex-wrap gap-2" role="group" aria-label={typeF.label}>
        <button type="button" className={pill(!filters.type)} aria-pressed={!filters.type} onClick={() => set("type", "")} data-testid="inspiration-filter-type-all">Alles</button>
        {typeF.options.filter(([v]) => present("type").has(v)).map(([v, l]) => (
          <button key={v} type="button" className={pill(filters.type === v)} aria-pressed={filters.type === v} onClick={() => set("type", v)} data-testid={`inspiration-filter-type-${v}`}>{l}</button>
        ))}
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-4">
        {rest.map((f) => (
          <label key={f.key} className="grid min-w-0 gap-1 text-[12.5px] font-semibold uppercase tracking-wide text-slate-500">
            {f.label}
            <select value={filters[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} data-testid={`inspiration-filter-${f.key}`}
              className="h-11 w-full min-w-0 rounded-xl border border-slate-300 bg-white px-3 text-[14.5px] font-medium normal-case tracking-normal text-ink focus:border-maas focus:outline-none focus:ring-2 focus:ring-maas/20">
              <option value="">Alle</option>
              {f.options.filter(([v]) => present(f.key).has(v)).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </label>
        ))}
      </div>
      <div className="mt-4 flex items-center justify-between text-[14px]">
        <p className="text-slate-500" data-testid="inspiration-count">{count} {count === 1 ? "beeld" : "beelden"}</p>
        {active && <button type="button" onClick={() => setFilters({})} className="font-semibold text-maas hover:text-maas-hover" data-testid="inspiration-filter-reset">Filters wissen</button>}
      </div>
    </div>
  );
};
